import { render, staticRenderFns } from "./FeedbackDescription.vue?vue&type=template&id=2691d1fa&scoped=true"
import script from "./FeedbackDescription.vue?vue&type=script&lang=js"
export * from "./FeedbackDescription.vue?vue&type=script&lang=js"
import style0 from "./FeedbackDescription.vue?vue&type=style&index=0&id=2691d1fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2691d1fa",
  null
  
)

export default component.exports